import React from 'react';
import { Alert } from 'react-bootstrap';
import '../styles/FormSectionStatus.css';

import { statusTypes } from '../config/constants';

const FormSectionStatus = (props) => {
  function mapInvalidProps(){
    return props.invalidElements.map((element) => {
      return (
        <li key={element}>{element}</li>
      );
    });
  }

  function renderInvalidProps(){
    if(props.status === statusTypes.SUCCESS ||
      props.invalidElements.length === 0)
      return null;
    return (
      <ul className="list-inline element-list">
        {mapInvalidProps()}
      </ul>
    )
  };
  return(
    <Alert bsStyle={props.status} className="section-status">
      {props.message}
      {renderInvalidProps()}
    </Alert>
  );
};

export default FormSectionStatus;